<template>
    <div>
        <div class="Card">
            <div class="Card__title">Vzhled</div>
            <div class="form__row">
                <label class="flex-1">Velikost písma</label>
                <div class="form__controls">
                    <input class="mt-4" type="range" v-model="data.options.font_size" min="10" max="20" @change="changeFontSize">
                </div>
            </div>
<!--
            <div class="form__row">
                <label class="flex-1">Primární barva</label>
                <div class="form__controls">
                    <input class="w-32" type="text" placeholder="#" v-model="data.options.accent" @change="changeAccent">
                </div>
            </div>
 -->
        </div>
        <div class="Card">
            <div class="Card__title">Notifikace</div>

            <label class="block text-left">
                <input class="form__checkbox" type="checkbox" value="1" v-model="data.options.notify_new_message">
                chci dostávat emailové notifikace o nových zprávách
            </label>
<!--
            <label class="block text-left">
                <input class="form__checkbox" type="checkbox" value="1" v-model="data.options.notify_archived_message">
                chci notifikace o zprávách v archivovaných konverzacích
            </label>
-->

        </div>
        <div class="form__buttons">
            <btn
                :loading="loading"
                :disabled="loading"
                @click.native="reset()"
            >
                <icon name="rotate-ccw"/>
                Reset
            </btn>
            <btn class="btn--primary"
                :loading="loading"
                :disabled="loading"
                @click.native="save()"
            >
                Uložit
                <icon name="chevron-right"/>
            </btn>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        user: {
            required: true
        }
    },

    data() {
        return {
            loading: false,
            data: {
                options: this.user.options
            }
        }
    },

    methods: {

        changeFontSize() {
            document.documentElement.style
                .setProperty('--base-font-size', `${this.data.options.font_size}px`);
        },

        changeAccent() {
            document.documentElement.style
                .setProperty('--accent', this.data.options.accent);
        },

        save() {
            this.loading = true;
            axios.patch(url(`/users/${this.user.id}/options`), this.data)
                .then(result => {
                    this.loading = false;
                    Notify.info('Nastavení bylo uloženo');
                })
                .catch(error => {
                    this.loading = false;
                    console.log(error.response);
                    alert('unexpected error');
                });
        },

        reset() {
            this.loading = true;
            axios.patch(url(`/users/${this.user.id}/options`), {options:null})
                .then(result => {
                    this.loading = false;
                    location.reload();
                })
                .catch(error => {
                    this.loading = false;
                    console.log(error.response);
                    alert('unexpected error');
                });
        },
    }
}
</script>
